import { render } from "./AppEventTemplateStripoEditor.vue?vue&type=template&id=71f7e772"
import script from "./AppEventTemplateStripoEditor.vue?vue&type=script&lang=js"
export * from "./AppEventTemplateStripoEditor.vue?vue&type=script&lang=js"

import "./AppEventTemplateStripoEditor.vue?vue&type=style&index=0&id=71f7e772&lang=css"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__